import { css } from '@emotion/react';
import Image from 'next/image';
import React from 'react';

import { Box } from '@/box';
import { useTheme } from '@/ui/theme';
import { BodyCopy, Heading } from '@/ui/typography';

interface ConfirmationHeaderProps {
  title: string;
  subtitle: string;
  confirmationMessage: string;
  headerImage?: { source: string; altText: string };
}

export const ConfirmationHeader: React.FC<ConfirmationHeaderProps> = (
  props
) => {
  const {
    colors,
    componentProperties: { confirmation },
  } = useTheme();

  return (
    <div
      css={{
        backgroundColor: colors.primary200,
        display: 'block',
        color: '#363636',
        overflow: 'auto',
        paddingBottom: '324px',
        ...confirmation?.header,
        '@media all and (max-width: 730px)': confirmation?.header?.mobile,
      }}
    >
      {props.headerImage ? (
        <div
          css={{
            margin: '64px auto 43px auto',
            width: '188px',
            ...confirmation?.headerImage?.container,
            '@media all and (max-width: 730px)':
              confirmation?.headerImage?.container?.mobile,
          }}
        >
          <Image
            css={{
              width: '100%',
              objectFit: confirmation?.headerImage?.objectFit ?? 'contain',
              height: confirmation?.headerImage?.height,
              '@media all and (max-width: 730px)':
                confirmation?.headerImage?.mobile ?? {},
            }}
            src={props.headerImage?.source}
            alt={props.headerImage.altText}
            width={1512}
            height={480}
          />
        </div>
      ) : null}
      <Heading
        as="h1"
        style="heading3"
        textAlign="center"
        css={css({
          padding: '0 28px',
          ...confirmation?.title,
          '@media all and (max-width: 730px)': confirmation?.title?.mobile,
        })}
      >
        {props.title}
      </Heading>
      <div
        css={css`
          max-width: 65ch;
          margin: auto;
          box-sizing: content-box;
        `}
      >
        <BodyCopy
          textAlign="center"
          css={{
            padding: '28px',
            ...confirmation?.confirmationMessage,
            '@media all and (max-width: 730px)':
              confirmation?.confirmationMessage?.mobile,
          }}
        >
          <Box
            css={{
              paddingBottom: '24px',
              ...confirmation?.confirmationMessage?.subtitle,
            }}
          >
            {props.subtitle}
          </Box>
          {props.confirmationMessage}
        </BodyCopy>
      </div>
    </div>
  );
};
